import { initializeApp } from 'firebase/app'
import { getAnalytics, isSupported } from 'firebase/analytics'
import { getFunctions } from 'firebase/functions'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'

// Use environment variables to load configuration based on REACT_APP_ENVIRONMENT (dev, prod, or any alias e.g. demo)
function getEnvPrefix(): string {
  return (process.env.REACT_APP_ENVIRONMENT || '').toUpperCase()
}

function buildFirebaseConfig() {
  const prefix = getEnvPrefix()
  return {
    apiKey: process.env[`REACT_APP_${prefix}_FIREBASE_API_KEY`],
    authDomain: process.env[`REACT_APP_${prefix}_FIREBASE_AUTH_DOMAIN`],
    projectId: process.env[`REACT_APP_${prefix}_FIREBASE_PROJECT_ID`],
    storageBucket: process.env[`REACT_APP_${prefix}_FIREBASE_STORAGE_BUCKET`],
    messagingSenderId: process.env[`REACT_APP_${prefix}_FIREBASE_MESSAGING_SENDER_ID`],
    appId: process.env[`REACT_APP_${prefix}_FIREBASE_APP_ID`],
    measurementId: process.env[`REACT_APP_${prefix}_FIREBASE_MEASUREMENT_ID`],
    recaptchaSiteKey: process.env[`REACT_APP_${prefix}_RECAPTCHA_ENTERPRISE_SITE_KEY`],
  }
}

const firebaseConfig = buildFirebaseConfig()

// Initialize Firebase
const app = initializeApp(firebaseConfig)

const prefix = getEnvPrefix()
const debugToken = process.env[`REACT_APP_${prefix}_FIREBASE_APPCHECK_DEBUG_TOKEN`]
if (debugToken) {
  // @ts-expect-error: Setting debug token for App Check in development
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken
}

initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(firebaseConfig.recaptchaSiteKey || ''),
  isTokenAutoRefreshEnabled: true,
})

// Initialize Firebase Analytics (only in supported environments, e.g. browser)
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app)
  }
})

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)
